import React from 'react';
import PropTypes from 'prop-types';
import rf from 'images/rf1.jpg';
import pft from 'images/pf1.png';
import fd from 'images/fd1.png';
import ifi from 'images/ifi1.png';
import ah from 'images/ah1.png';
import lhi from 'images/lhi1.png';
import bj from 'images/bj1.png';
import sam from 'images/sam1.png';
import way from 'images/way1.png';
import { ALL_SOURCES, LHI_SOURCES } from 'config/constants';

const IMAGES = { rf, pft, fd, ifi, ah, lhi, bj, sam, way };

const VendorLogo = ({ workroomName, source, styling, classMap }) => {
  let vendor = source;
  if (workroomName && workroomName.includes('PFT-')) vendor = 'PFT';
  else if (!ALL_SOURCES.includes(vendor)) return null;
  else if (LHI_SOURCES.includes(vendor)) vendor = 'LHI';
  const lowerCaseVendor = vendor.toLowerCase();
  const imgSrc = IMAGES[lowerCaseVendor];
  if (!imgSrc) return null;
  const resolvedClass = classMap ? classMap[`${lowerCaseVendor}Img`] : styling;
  return <img src={imgSrc} alt={vendor} className={resolvedClass} />;
};


VendorLogo.propTypes = {
  workroomName: PropTypes.string,
  source: PropTypes.string,
  styling: PropTypes.string,
  classMap: PropTypes.object,
};

VendorLogo.defaultProps = {
  workroomName: '',
  source: '',
  styling: '',
  classMap: null,
};

export default VendorLogo;



// WEBPACK FOOTER //
// ./client/app/shared/components/VendorLogo/index.jsx